import { NotebookShareScope } from "models/enumerations/notebooks/notebook-share-scope";
import PageRecord from "models/view-models/page-record";
import SharedPageEntry from "molecules/shared-page-access-list/shared-page-entry";
import React from "react";

interface SharedPageListProps {
    allPagesInNotebook: PageRecord[];
    currentSharedPages: PageRecord[];
    currentScope: NotebookShareScope;
    onScopeChange: (newScope: NotebookShareScope) => void;
    onPageShareChange: (pages: PageRecord[]) => void;
}

const CSS_CLASS_NAME = "c-shared-page-list";
const SharedPageList = (props: SharedPageListProps) => {
    const {
        allPagesInNotebook,
        onScopeChange,
        onPageShareChange,
        currentSharedPages,
        currentScope,
    } = props;
    const sharingEntireNotebook =
        currentScope === NotebookShareScope.EntireNotebook;

    const handleShareAllToggle = () => {
        const isChangingToSelectPageScope = sharingEntireNotebook;
        onScopeChange(
            isChangingToSelectPageScope
                ? NotebookShareScope.SelectPages
                : NotebookShareScope.EntireNotebook
        );
        // If switching to only share some pages, auto-select all pages
        if (isChangingToSelectPageScope) {
            onPageShareChange(allPagesInNotebook);
        }
    };

    const isPageShared = (pageId: number) => {
        return currentSharedPages.some(
            (sharedPage) => sharedPage.id === pageId
        );
    };

    const handlePageUpdate = (page: PageRecord) => {
        const updatedListOfSharedPages = isPageShared(page.id!)
            ? currentSharedPages.filter(
                  (currentlySharedPage) => currentlySharedPage.id !== page.id
              )
            : [...currentSharedPages, page];
        onPageShareChange(updatedListOfSharedPages);
    };

    return (
        <div className={CSS_CLASS_NAME}>
            <div className={`${CSS_CLASS_NAME}__section`}>
                <SharedPageEntry
                    label={"Share all pages"}
                    idOrScope={NotebookShareScope.EntireNotebook}
                    isChecked={sharingEntireNotebook}
                    isDisabled={false}
                    onClick={handleShareAllToggle}
                />
            </div>
            <div className={`${CSS_CLASS_NAME}__section by-id`}>
                {allPagesInNotebook.map((page) => (
                    <SharedPageEntry
                        key={page.id}
                        label={page.name}
                        idOrScope={page.id!}
                        isChecked={
                            sharingEntireNotebook || isPageShared(page.id!)
                        }
                        isDisabled={sharingEntireNotebook}
                        onClick={() => handlePageUpdate(page)}
                    />
                ))}
            </div>
        </div>
    );
};

export default SharedPageList;
